import { navigateToTeamsApp as navigateToTeamsAppBase } from '@atlaskit/teams-app-config/navigation';
import type {
	NavigationActionPayloadVariants,
	NavigationResult,
} from '@atlaskit/teams-app-config/types';
import { useOrgId } from '@atlassian/jira-router-resources-navigation-org-id/src/index.tsx';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';
import { useRouterActions } from '@atlassian/react-resource-router';
import { getWillShowNav4 } from '@atlassian/jira-navigation-apps-sidebar-nav4-rollout-core/src/common/utils/get-will-show-nav4/index.tsx';
import getMeta from '@atlassian/jira-get-meta';

export const useNavigateToTeamsApp = (
	navActionPayload: NavigationActionPayloadVariants,
	shouldOpenInSameTab?: boolean,
): NavigationResult => {
	const { data: orgId } = useOrgId();
	const cloudId = useCloudId();
	const { push } = useRouterActions();

	if (!orgId) {
		throw new Error('Org ID is required to navigate to Teams App');
	}

	return navigateToTeamsAppBase({
		push,
		hostProduct: 'jira',
		orgId,
		cloudId,
		userHasNav4Enabled: getWillShowNav4(),
		shouldOpenInSameTab,
		...navActionPayload,
	});
};

export const getNavigateToTeamsApp = (
	navActionPayload: NavigationActionPayloadVariants,
	shouldOpenInSameTab?: boolean,
): NavigationResult => {
	const orgId = getMeta('ajs-org-id');

	if (!orgId) {
		throw new Error('Org ID is required to navigate to Teams App');
	}

	return navigateToTeamsAppBase({
		hostProduct: 'jira',
		orgId,
		userHasNav4Enabled: getWillShowNav4(),
		shouldOpenInSameTab,
		...navActionPayload,
	});
};
